import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import _ from "lodash";

const ConfirmationCodeInput = (props) => {
  const { control } = props.formController;

  return (
    <Controller
      name="code"
      control={control}
      defaultValue=""
      rules={{
        required: "Code is required.",
      }}
      render={({ field, fieldState }) => {
        return (
          <TextField
            autoComplete="one-time-code"
            label={props.label}
            required={true}
            error={fieldState.error !== undefined}
            helperText={fieldState.error?.message}
            {...field}
          />
        );
      }}
    />
  );
};

export default ConfirmationCodeInput;
